module.exports = __webpack_public_path__ + "28b67065/img/SOURCERY_poweredby_web.9819842b.png";